/**
 * THE CAST MANIFEST — GENERATED, DO NOT HAND-EDIT.
 *
 * Regenerate with `node scripts/freeze-cast-manifest.mjs`; `--check` diffs it.
 *
 * Thirty-six characters (32 players across two clubs, 2 coaches, 2 officials),
 * each with a four-level LOD ladder. The ROSTER half (club, shirt number,
 * position, starter/bench) comes from the art pipeline's own variant configs;
 * the MESH half is measured off the shipped GLBs — joints, sockets, primitives,
 * materials, triangles, bind height, and the VRAM its textures occupy once
 * uploaded (RGBA8+mips for `cast/`, 4 bpp block format for `cast-opt/`).
 *
 * Nothing here is a verdict. `castContract.ts` turns these measurements into
 * one, so the freezer and the browser loader cannot disagree.
 *
 * ⚠ `textureVramBytes` is per FILE, and for `cast-opt/` that is now an
 * OVER-count rather than the truth. three.js de-duplicates images inside one
 * glTF and never across two, which is why the authored cast costs what it costs
 * — but the optimised cast points all 36 characters at one `_shared/` KTX2
 * pool and `castDecoders.ts` caches those by URL across files, so the same
 * skin-detail normal is uploaded ONCE for the whole cast. Summing this field
 * across characters gives 116 MB; the resident total measured on the GPU is
 * 1.6 MB. Read it per file, never as a scene total.
 */

import type { CastLodLevel } from './castContract';

export const CAST_MANIFEST_VERSION = "cast36-1.b23dbbf2572066b2";

export type CastRole = 'player' | 'coach' | 'official';

export interface CastLodAsset {
  readonly lod: CastLodLevel;
  readonly url: string;
  readonly bytes: number;
  readonly sha256: string;
  readonly meshes: number;
  readonly primitives: number;
  readonly materials: number;
  readonly textures: number;
  readonly triangles: number;
  readonly bones: number;
  readonly rootBone: string | null;
  readonly sockets: number;
  readonly maxInfluences: number;
  readonly animations: number;
  readonly heightM: number;
  readonly soleM: number;
  /** RGBA8 + mips, in bytes. What lands in VRAM, not what sits on disk. */
  readonly textureVramBytes: number;
}

export interface CastCharacter {
  readonly id: string;
  readonly name: string;
  /** 'arena' | 'rivals' for players; null for coaches and officials. */
  readonly club: string | null;
  readonly role: CastRole;
  /** 'coach_old' | 'coach_young' | 'referee' | 'assistant', else null. */
  readonly staffRole: string | null;
  readonly number: number;
  readonly position: string;
  readonly starter: boolean;
  readonly foot: string;
  readonly kit: string | null;
  readonly declaredHeightM: number | null;
  readonly lods: readonly CastLodAsset[];
}

export const CAST_CHARACTERS: readonly CastCharacter[] = [
 {
  "id": "arena_adebayo",
  "name": "ADEBAYO",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 14,
  "position": "CB",
  "starter": false,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.88,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_adebayo/arena_adebayo-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_adebayo/arena_adebayo-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_adebayo/arena_adebayo-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_adebayo/arena_adebayo-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_brennan",
  "name": "BRENNAN",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 5,
  "position": "LCB",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.86,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_brennan/arena_brennan-lod0.glb",
    "bytes": 1827520,
    "sha256": "50573b83844071150c73b4a565bbceecc17651317decf83272ca127e989743bd",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.900001,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_brennan/arena_brennan-lod1.glb",
    "bytes": 1682264,
    "sha256": "24f514fe888d310b724cec250d3b98773020f26de9da8b518e6d792d215a806a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.90009,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_brennan/arena_brennan-lod2.glb",
    "bytes": 1040180,
    "sha256": "517a497825c5076e9b7dbdb4db45a3e113ada4d65b4e0d29b48df4b65afc88b5",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.901003,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_brennan/arena_brennan-lod3.glb",
    "bytes": 247856,
    "sha256": "7d8ffc3998bd9f3d66ca9d3598d9e2bb275a7c548ff74ca65cd348040ef53b4a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.900858,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_delaney",
  "name": "DELANEY",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 2,
  "position": "RB",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.83,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_delaney/arena_delaney-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_delaney/arena_delaney-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_delaney/arena_delaney-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_delaney/arena_delaney-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_ellis",
  "name": "ELLIS",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 9,
  "position": "ST",
  "starter": true,
  "foot": "L",
  "kit": "home",
  "declaredHeightM": 1.77,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_ellis/arena_ellis-lod0.glb",
    "bytes": 1741672,
    "sha256": "ca461f6957041fbd167a18721e252fea43bb2b367b22ba49264773731994308b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 28212,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_ellis/arena_ellis-lod1.glb",
    "bytes": 1635464,
    "sha256": "8ee5dfb2085c935e4c73a569e5f5369918f44dc349e5677306891b80f6db5f39",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_ellis/arena_ellis-lod2.glb",
    "bytes": 1051228,
    "sha256": "f2f2f9ca193feb4718a533713361f4709be682293143cfa77385c02780f1a766",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.802243,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_ellis/arena_ellis-lod3.glb",
    "bytes": 243432,
    "sha256": "11f8b56f0a972d8749cea33e820dcf59eb02e0f1ca95ae1c34ed8a4b81883176",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.799872,
    "soleM": 0.000001,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_ferraro",
  "name": "FERRARO",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 15,
  "position": "CM",
  "starter": false,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.8,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_ferraro/arena_ferraro-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_ferraro/arena_ferraro-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_ferraro/arena_ferraro-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_ferraro/arena_ferraro-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_hayes",
  "name": "HAYES",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 4,
  "position": "RCB",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.9,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_hayes/arena_hayes-lod0.glb",
    "bytes": 1784820,
    "sha256": "bec42f79185db0c6cd76220026e09a0e154902eee1f6143ace4f8a374c694f55",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29411,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.88,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_hayes/arena_hayes-lod1.glb",
    "bytes": 1640036,
    "sha256": "496a198d5cfa8bd8bffece3594092cb7308359ffa33aed7bd135096fcdcb6aa9",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.880127,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_hayes/arena_hayes-lod2.glb",
    "bytes": 1036068,
    "sha256": "56e411c53caa35e4a3c64a4d42cb1f5e1d06e27dba4ded99014f64d0153974e2",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.880548,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_hayes/arena_hayes-lod3.glb",
    "bytes": 242340,
    "sha256": "a3dcd68c83a483f237f385839467c152647d0f46867b00283947cd214db434de",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.874439,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_koval",
  "name": "KOVAL",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 3,
  "position": "LB",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.81,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_koval/arena_koval-lod0.glb",
    "bytes": 1774876,
    "sha256": "24b5aa43d753e3c42da0f71b998146190a8497a68d3fc6e38e89413035ca81ae",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29411,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.83,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_koval/arena_koval-lod1.glb",
    "bytes": 1630096,
    "sha256": "1cf2533e947e4866b0d65eaf7b67060c7cf66e9df76de62f1cc25592ab233818",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.830331,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_koval/arena_koval-lod2.glb",
    "bytes": 1051660,
    "sha256": "da0628500561f49b5ac82f6e480bf020156e7f107851f6a0589e91ac319feaf0",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.830738,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_koval/arena_koval-lod3.glb",
    "bytes": 242332,
    "sha256": "edfb2846ac0e6f07ee006610e0e6cd07f7e9916e81a425267f69d774597ace4b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.831225,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_lindqvist",
  "name": "LINDQVIST",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 16,
  "position": "RW",
  "starter": false,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.82,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_lindqvist/arena_lindqvist-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_lindqvist/arena_lindqvist-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_lindqvist/arena_lindqvist-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_lindqvist/arena_lindqvist-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_marchetti",
  "name": "MARCHETTI",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 10,
  "position": "CAM",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.87,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_marchetti/arena_marchetti-lod0.glb",
    "bytes": 1798924,
    "sha256": "a3af9b34abf9090ea119e07cd9288a2c539f8c5d2d085670dea77f96fd3a38ea",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29262,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.74,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_marchetti/arena_marchetti-lod1.glb",
    "bytes": 1658208,
    "sha256": "ea6227d39023c63b52667c7d438bc3ea6e5960c4bc7aad39311b2a1ba004e932",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.740135,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_marchetti/arena_marchetti-lod2.glb",
    "bytes": 1045868,
    "sha256": "30ddef4a7864b8dbf8942b5f8fa7d2f9c6156f0ed01ca903d329b800634b9dd1",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.745282,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_marchetti/arena_marchetti-lod3.glb",
    "bytes": 245688,
    "sha256": "a9959bb573ac57e6cd27b64e848883a39d1f5d3c985a3a5dd7f0117a3247b352",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 2999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.744626,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_moreau",
  "name": "MOREAU",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 17,
  "position": "ST",
  "starter": false,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.84,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_moreau/arena_moreau-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_moreau/arena_moreau-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_moreau/arena_moreau-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_moreau/arena_moreau-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_nakamura",
  "name": "NAKAMURA",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 7,
  "position": "RW",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.73,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_nakamura/arena_nakamura-lod0.glb",
    "bytes": 1790428,
    "sha256": "eef08c9b76accce9e693b9c3125fece3970256687520ef1a82debed43d392826",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.71,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_nakamura/arena_nakamura-lod1.glb",
    "bytes": 1645716,
    "sha256": "4d8da3599373993a87b22c413d51af456d3c7f647d28e1a2bbd88d5bbd669df6",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.71,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_nakamura/arena_nakamura-lod2.glb",
    "bytes": 1039180,
    "sha256": "a5032784c744296756d5b7a56da846eeea80fd73e9eacb5833779ebeb9f0aa88",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.710294,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_nakamura/arena_nakamura-lod3.glb",
    "bytes": 241032,
    "sha256": "b0200b6c70b66076b2a42546ae0b3c067d08ce72cf291ba3b2be95e7c31b69c1",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.71916,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_okonkwo",
  "name": "OKONKWO",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 6,
  "position": "CDM",
  "starter": true,
  "foot": "L",
  "kit": "home",
  "declaredHeightM": 1.78,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_okonkwo/arena_okonkwo-lod0.glb",
    "bytes": 1744204,
    "sha256": "6b7b55b01539b9a95ade31ee0f9ff2780aadc6db75e5c6677653b0e908a3c194",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 28210,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.849999,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_okonkwo/arena_okonkwo-lod1.glb",
    "bytes": 1638376,
    "sha256": "b1fca88a5e5507071335dd6b62669154ead5c3eda6ac57937777f8e3fddf7108",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.849999,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_okonkwo/arena_okonkwo-lod2.glb",
    "bytes": 1043276,
    "sha256": "fe6019f2065ec37f88baf61faa821b103ed9bfe7b4360c6bc9ba8f6dc661bc67",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.850973,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_okonkwo/arena_okonkwo-lod3.glb",
    "bytes": 246376,
    "sha256": "18c455a9456e7a1bb684162afac7967b62460a3ea65a0ef4ae3f733039f2458c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.854449,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_reynolds",
  "name": "REYNOLDS",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 8,
  "position": "CM",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.79,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_reynolds/arena_reynolds-lod0.glb",
    "bytes": 1776976,
    "sha256": "c51ee1d0284c1fa3c14025cf04275a61bcd9af2857041b09d726e9d9ff839935",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.78,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_reynolds/arena_reynolds-lod1.glb",
    "bytes": 1632092,
    "sha256": "02d29b37aa8b43226bf8ecbd1a7cce179ff328df78ff05cec1b636f1f35d33dd",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.780447,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_reynolds/arena_reynolds-lod2.glb",
    "bytes": 1041740,
    "sha256": "4681e84e18e651a0605eb151a8294531fe6c72e108609145f62612e3bd57d357",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.783769,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_reynolds/arena_reynolds-lod3.glb",
    "bytes": 238184,
    "sha256": "36e1e518bd1ee4962d43127218ac898b6b989c872d16e2f7462b152d29bcfc91",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.782019,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_santos",
  "name": "SANTOS",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 11,
  "position": "LW",
  "starter": true,
  "foot": "R",
  "kit": "home",
  "declaredHeightM": 1.74,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_santos/arena_santos-lod0.glb",
    "bytes": 1821596,
    "sha256": "6d874aabd00f488d66c4253426b10b94b75921b433319f812a929a37ef6a8019",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.72,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_santos/arena_santos-lod1.glb",
    "bytes": 1676780,
    "sha256": "a330a8107479c9e26304015b5a8b840a7406aadfbdfa907b59eb3dedf4a96d2d",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.72,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_santos/arena_santos-lod2.glb",
    "bytes": 1044604,
    "sha256": "7ef42bd362984b27db8e5c007116f4a319beb5ac4729271becdedff2213a00bf",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.722483,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_santos/arena_santos-lod3.glb",
    "bytes": 241048,
    "sha256": "9364eab9672c25e32953832e69cc94dedef021b3783877f074cb8fd0519d21dc",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.715428,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_vance",
  "name": "VANCE",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 1,
  "position": "GK",
  "starter": true,
  "foot": "R",
  "kit": "gk",
  "declaredHeightM": 1.89,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_vance/arena_vance-lod0.glb",
    "bytes": 1818796,
    "sha256": "f31a71287eaae8919a5301a52ecc7186bebfaba4724ad7bf4ced6aeaa10186e7",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 30000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.930024,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_vance/arena_vance-lod1.glb",
    "bytes": 1655580,
    "sha256": "dab164cc9ac3e96c350403d46bd879be303c45679304e999bd21f2d70741590b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.930024,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_vance/arena_vance-lod2.glb",
    "bytes": 1006524,
    "sha256": "c146679895f1eb8c8ffd0d94084cef3c772031d0f92db8972f56065887726d9f",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.932986,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_vance/arena_vance-lod3.glb",
    "bytes": 240152,
    "sha256": "9f010f9d33acddc8010e6bc4ffe53fbb8236e696e303fa8156173444205287be",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.939355,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "arena_whitlock",
  "name": "WHITLOCK",
  "club": "arena",
  "role": "player",
  "staffRole": null,
  "number": 13,
  "position": "GK",
  "starter": false,
  "foot": "R",
  "kit": "gk",
  "declaredHeightM": 1.91,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/arena_whitlock/arena_whitlock-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/arena_whitlock/arena_whitlock-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/arena_whitlock/arena_whitlock-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/arena_whitlock/arena_whitlock-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "coach_a",
  "name": "HARGREAVES",
  "club": null,
  "role": "coach",
  "staffRole": "coach_old",
  "number": 0,
  "position": "STAFF",
  "starter": false,
  "foot": "R",
  "kit": "coach_suit",
  "declaredHeightM": 1.79,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/coach_a/coach_a-lod0.glb",
    "bytes": 1774420,
    "sha256": "4cda77f092d03e52babe65ba0ddd014bb8ae57338db6bb3c2b5bf213666b5fd1",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29411,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.78,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/coach_a/coach_a-lod1.glb",
    "bytes": 1630180,
    "sha256": "3159022154d99cf8b7d4dbc27b81125da74ea8805b8070b330b614dd956dd282",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.78,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/coach_a/coach_a-lod2.glb",
    "bytes": 1034668,
    "sha256": "46e6d7f98c061a758cd02132fa373cec81e5d7a37a5a79ed33a6be52e211bcac",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.780849,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/coach_a/coach_a-lod3.glb",
    "bytes": 239584,
    "sha256": "9d280b71fb609a4ced74aa348e178dbef7613d379722144ff65efba19e2b52a7",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 2999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.802446,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "coach_b",
  "name": "RIOS",
  "club": null,
  "role": "coach",
  "staffRole": "coach_young",
  "number": 0,
  "position": "STAFF",
  "starter": false,
  "foot": "R",
  "kit": "coach_track",
  "declaredHeightM": 1.83,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/coach_b/coach_b-lod0.glb",
    "bytes": 1824956,
    "sha256": "040380a2ddb60c7ba4abaa7f4f2f1aeb336aceee53da2b621be36cb1e81098c0",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.82,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/coach_b/coach_b-lod1.glb",
    "bytes": 1679988,
    "sha256": "34358429a796fe62ad2d4fa9d7d7fd9c0b25bd9baaf8ee682f01366f17d6e810",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.82,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/coach_b/coach_b-lod2.glb",
    "bytes": 1051348,
    "sha256": "661eacbde6bac289fc7d557d077871cb88307b2a2e656bdbfeb2bb7c97c70f10",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.822278,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/coach_b/coach_b-lod3.glb",
    "bytes": 242332,
    "sha256": "974baa67bd978b871c510e5204e84a8b7f764fb7d933bb0c08b2864a1c68faef",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.820416,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "ref_asst",
  "name": "IKEDA",
  "club": null,
  "role": "official",
  "staffRole": "assistant",
  "number": 0,
  "position": "STAFF",
  "starter": false,
  "foot": "R",
  "kit": "referee_alt",
  "declaredHeightM": 1.76,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/ref_asst/ref_asst-lod0.glb",
    "bytes": 1786096,
    "sha256": "22f35fd9322a62813ee37f01d4495f8ac0ca371a086a49d2c001a81ce0d38af2",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29492,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.76,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/ref_asst/ref_asst-lod1.glb",
    "bytes": 1639344,
    "sha256": "cdfd0b379c05afbb10a1fce82d54c2df4637280d7d79d353c490bb52533f623c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.760037,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/ref_asst/ref_asst-lod2.glb",
    "bytes": 1037588,
    "sha256": "176d47c3c4a39855f146eb20a460a3118af320a855788c20434c74dbb5224487",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.76015,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/ref_asst/ref_asst-lod3.glb",
    "bytes": 238524,
    "sha256": "5afa96360d1f9114476f674376fccfd130f4a1876131092c868f3abe0810dc5f",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 2999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.756254,
    "soleM": 0.000175,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "ref_main",
  "name": "OSTERGAARD",
  "club": null,
  "role": "official",
  "staffRole": "referee",
  "number": 0,
  "position": "STAFF",
  "starter": false,
  "foot": "R",
  "kit": "referee",
  "declaredHeightM": 1.81,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/ref_main/ref_main-lod0.glb",
    "bytes": 1806088,
    "sha256": "1fc9b5f693e510ff924d5e28247f1c9c3a40c55007c77d4ae6aacfeaf84cb8ca",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29258,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/ref_main/ref_main-lod1.glb",
    "bytes": 1666048,
    "sha256": "30c3802242c50515652e9cf41fc3366807e9559d28f99daa91b4ae4ee16e7d21",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/ref_main/ref_main-lod2.glb",
    "bytes": 1045780,
    "sha256": "5722b81e823f3d19942aec5927330f65388e7ddec595f8fafc341b3717d9eb8c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.804612,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/ref_main/ref_main-lod3.glb",
    "bytes": 241388,
    "sha256": "812809801fe92a6f6d2134b119b8f27ec41392bddf4b598721e5b2d2a0d2196c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.806104,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_baptiste",
  "name": "BAPTISTE",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 11,
  "position": "LW",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.76,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_baptiste/rivals_baptiste-lod0.glb",
    "bytes": 1748216,
    "sha256": "2900d3dfba3efed37352806ecb719691d843a08a2872c95582a5fdfc8ca02dc9",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 28211,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.68,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_baptiste/rivals_baptiste-lod1.glb",
    "bytes": 1642580,
    "sha256": "a70f778530eb5fe52ed135de43ac12fe2d765bd1a473587dda68510894431ab5",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.68,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_baptiste/rivals_baptiste-lod2.glb",
    "bytes": 1054732,
    "sha256": "d62edeea15cdb9b18bfd82f27e73a7d0f3dc7f8ba8822922b0dd9278243ccdad",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.680984,
    "soleM": 0.000001,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_baptiste/rivals_baptiste-lod3.glb",
    "bytes": 247376,
    "sha256": "5e65aef7dac326ba8c8c8b576ad035835f62fd20be492d9931868bae5e442db1",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 2999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.679214,
    "soleM": 0.000001,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_blackwood",
  "name": "BLACKWOOD",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 2,
  "position": "RB",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.8,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_blackwood/rivals_blackwood-lod0.glb",
    "bytes": 1784976,
    "sha256": "0222737ed0182cefa2acef29b4bbfb695c828492247677f02089198b40b1498b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.79,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_blackwood/rivals_blackwood-lod1.glb",
    "bytes": 1640452,
    "sha256": "c086ed05759a94b87ebfe0a1be8acec4918db1cf3fcced21c26f4eb033085b9d",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.790337,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_blackwood/rivals_blackwood-lod2.glb",
    "bytes": 1052132,
    "sha256": "ee8acace613defb1684f59d2921c5973c36fce22c6806d1d30f694aa812d6a2c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.791569,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_blackwood/rivals_blackwood-lod3.glb",
    "bytes": 242980,
    "sha256": "03d17c2adb6e3f274d7a6e9298566e0846f76aba527355dcf4378f6e419f042f",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.789726,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_callaghan",
  "name": "CALLAGHAN",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 17,
  "position": "ST",
  "starter": false,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.87,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_callaghan/rivals_callaghan-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_callaghan/rivals_callaghan-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_callaghan/rivals_callaghan-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_callaghan/rivals_callaghan-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_diallo",
  "name": "DIALLO",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 3,
  "position": "LB",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.77,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_diallo/rivals_diallo-lod0.glb",
    "bytes": 1743644,
    "sha256": "bcbf7ebba4415fb80fa7a8434565a8dc042d5ebb22823b0c9aaca9d8c5ef5b40",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 28211,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.84,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_diallo/rivals_diallo-lod1.glb",
    "bytes": 1637860,
    "sha256": "6c14bfe49ad943ea52729a05350f7193d0f89bfd1d91aa29968ccccaa8665c4e",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.84,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_diallo/rivals_diallo-lod2.glb",
    "bytes": 1048272,
    "sha256": "fa386b46f5fb0968fc285d85b89fafe27391f6825a7fe016aa5c3ad49dc577a0",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.842078,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_diallo/rivals_diallo-lod3.glb",
    "bytes": 244920,
    "sha256": "0cd8c1f7c8bf25c1577b3fe0c976737c72d44b638b79026adf21911f887985cc",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8437,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_esposito",
  "name": "ESPOSITO",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 5,
  "position": "LCB",
  "starter": true,
  "foot": "L",
  "kit": "away",
  "declaredHeightM": 1.88,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_esposito/rivals_esposito-lod0.glb",
    "bytes": 1790040,
    "sha256": "30ad08b5ea6f39caf18f4f7c7cc02c1ac1a3fd24e013d7740e57263dd5f998b6",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29261,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.860001,
    "soleM": -0.000001,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_esposito/rivals_esposito-lod1.glb",
    "bytes": 1649848,
    "sha256": "c280ad2601624a4bf863989d589c6cad4c90d21b08d9434db95c750a902df821",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.860136,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_esposito/rivals_esposito-lod2.glb",
    "bytes": 1044320,
    "sha256": "95b84fdf494b843758977d6c39fe6af529c3c6b8deb19461d8e9104282d0ca36",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.864917,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_esposito/rivals_esposito-lod3.glb",
    "bytes": 240924,
    "sha256": "2e469e866242645688433aa7a0fabd0c9132cae67f927825518cf88ae195d51a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.867353,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_harlow",
  "name": "HARLOW",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 10,
  "position": "CAM",
  "starter": true,
  "foot": "L",
  "kit": "away",
  "declaredHeightM": 1.78,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_harlow/rivals_harlow-lod0.glb",
    "bytes": 1801732,
    "sha256": "99974669b51ea14e7c3b370cb01bb566d0f009263951e47bf54b2232862115a9",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29262,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.769999,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_harlow/rivals_harlow-lod1.glb",
    "bytes": 1661328,
    "sha256": "365305f2fb15774d095c50adca8bdd1f3993eaa40f4324b3a35e221be1733943",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.770134,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_harlow/rivals_harlow-lod2.glb",
    "bytes": 1047636,
    "sha256": "3fe0b7d44591e19856e6de79f9debecaf50e30672ccc8c75d1d961e204db91bb",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.775269,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_harlow/rivals_harlow-lod3.glb",
    "bytes": 245332,
    "sha256": "87c98d9765a1147b6554d22aa37c01741a57c2cb904b38030db42507c84d2707",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.774464,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_holmgren",
  "name": "HOLMGREN",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 4,
  "position": "RCB",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.9,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_holmgren/rivals_holmgren-lod0.glb",
    "bytes": 1785700,
    "sha256": "0d4875ce225f76bd549bd53da66b4a1c007e0dc58484172d95399180d658fe8b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29411,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.92,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_holmgren/rivals_holmgren-lod1.glb",
    "bytes": 1641080,
    "sha256": "4364a4975a5a06fb2f4fb6b03d78136cec73ba75a084d6c64f800911a45f30f1",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.920138,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_holmgren/rivals_holmgren-lod2.glb",
    "bytes": 1040324,
    "sha256": "9994d9a7166acbe99b031beb30cdacdb85cfe04ad9dd56675051e4a76d6e5f52",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.920119,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_holmgren/rivals_holmgren-lod3.glb",
    "bytes": 242544,
    "sha256": "b614ba76360d68d37d282b873bbc4d0ef66d81b4e49cd78fdc2f8cd99bbf44f6",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.92026,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_kaufmann",
  "name": "KAUFMANN",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 13,
  "position": "GK",
  "starter": false,
  "foot": "R",
  "kit": "gk_alt",
  "declaredHeightM": 1.89,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_kaufmann/rivals_kaufmann-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_kaufmann/rivals_kaufmann-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_kaufmann/rivals_kaufmann-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_kaufmann/rivals_kaufmann-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_mendes",
  "name": "MENDES",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 9,
  "position": "ST",
  "starter": true,
  "foot": "L",
  "kit": "away",
  "declaredHeightM": 1.85,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_mendes/rivals_mendes-lod0.glb",
    "bytes": 1826164,
    "sha256": "e74bb67ca8eb850599ac41ddd25c9b7acf4b0db193aa0ecb2e2c95088bb47094",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.81,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_mendes/rivals_mendes-lod1.glb",
    "bytes": 1681404,
    "sha256": "8762727857e0d8d6777ff1b36f4b448e2ca631622b3db2b89c310aad5cb4913a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.81,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_mendes/rivals_mendes-lod2.glb",
    "bytes": 1052968,
    "sha256": "d23490ed4a7928c81755cb0f1c5f7ec6f158238f0b87ca6c452ef98b252007e5",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.811366,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_mendes/rivals_mendes-lod3.glb",
    "bytes": 244960,
    "sha256": "f3ac5092dfff2b3686e05e6d89f18350469466c54616e40bd8de2bdfe7b2d051",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 2999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808618,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_oyelaran",
  "name": "OYELARAN",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 15,
  "position": "CM",
  "starter": false,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.82,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_oyelaran/rivals_oyelaran-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_oyelaran/rivals_oyelaran-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_oyelaran/rivals_oyelaran-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_oyelaran/rivals_oyelaran-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_park",
  "name": "PARK",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 6,
  "position": "CDM",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.81,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_park/rivals_park-lod0.glb",
    "bytes": 1781100,
    "sha256": "0382893ce4709d6e63f2e1cde2b066a36fe761ea76fb514a134078efe2a7e80b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29409,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.75,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_park/rivals_park-lod1.glb",
    "bytes": 1636212,
    "sha256": "af6d356a1660954443a0dc48c1e5f7ca07009e1f4bd241dc8bf5473273335aa2",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.749783,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_park/rivals_park-lod2.glb",
    "bytes": 1031072,
    "sha256": "0d2d36029443251e183d66c4b4000bb3f4ba4e43c895c3b92e126720872cc1f3",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.750221,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_park/rivals_park-lod3.glb",
    "bytes": 238076,
    "sha256": "ff61b14baaec2bd128251bd1e2a1e5a89cc0525f0b5262859c3f0741696563d2",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.751759,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_petrov",
  "name": "PETROV",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 16,
  "position": "LW",
  "starter": false,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.79,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_petrov/rivals_petrov-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_petrov/rivals_petrov-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_petrov/rivals_petrov-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_petrov/rivals_petrov-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_quinn",
  "name": "QUINN",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 7,
  "position": "RW",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.75,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_quinn/rivals_quinn-lod0.glb",
    "bytes": 1787756,
    "sha256": "8714d6cbdba2a460092ca91a1ba7d385bdbe9a6d220db8913d372c9a55660913",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29412,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.73,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_quinn/rivals_quinn-lod1.glb",
    "bytes": 1642504,
    "sha256": "6928209f7f96881f2d552f061dfc689ee2942b45ebae9a7426596e99bfeb925e",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.730129,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_quinn/rivals_quinn-lod2.glb",
    "bytes": 1048516,
    "sha256": "4f688dcdf811e3c00f556dbe537e1f34f8ac7a969cc296af8ba4651dae082cec",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.731312,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_quinn/rivals_quinn-lod3.glb",
    "bytes": 247116,
    "sha256": "a33b3269098d414cf9792e69b299d666b30acce66cdda9726e22e061586a1e35",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.726819,
    "soleM": 0.000001,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_rashid",
  "name": "RASHID",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 14,
  "position": "CB",
  "starter": false,
  "foot": "L",
  "kit": "away",
  "declaredHeightM": 1.86,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_rashid/rivals_rashid-lod0.glb",
    "bytes": 1769740,
    "sha256": "1d1a0ad7d3254629e89c24f8759e0bbc228cd9eea73044f197e4ab470e3a410c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29378,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_rashid/rivals_rashid-lod1.glb",
    "bytes": 1626268,
    "sha256": "d327b5f44468800f1c97e3d51ae9685ace8a5da0c04b91b76c960b21b9651f1a",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.8039,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_rashid/rivals_rashid-lod2.glb",
    "bytes": 1032856,
    "sha256": "1fbff01caa3c9a22e2e7818af421b8ade9a53e43e0de0dd8375d466aa0989a22",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 9999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.807287,
    "soleM": 0.002203,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_rashid/rivals_rashid-lod3.glb",
    "bytes": 238868,
    "sha256": "01133296efc1c734b2a593e2b9aa9db431f617d609c038a5804b63a60f39f349",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.808393,
    "soleM": 0.002011,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_sorrentino",
  "name": "SORRENTINO",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 1,
  "position": "GK",
  "starter": true,
  "foot": "R",
  "kit": "gk_alt",
  "declaredHeightM": 1.92,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_sorrentino/rivals_sorrentino-lod0.glb",
    "bytes": 1854720,
    "sha256": "1950c94ea20e4b00ac802b6874dc6fe023ecbd214a1f84899b356b9d23b69aa5",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 30000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.950121,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_sorrentino/rivals_sorrentino-lod1.glb",
    "bytes": 1691088,
    "sha256": "e4fd23ea377e93d80e6d03f9516e94f88a3dbbd5463e62a0506a6d368e7db083",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 25000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.950253,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_sorrentino/rivals_sorrentino-lod2.glb",
    "bytes": 1009788,
    "sha256": "a4e79db917d755f8bc8e59dbdb4ae964856a9a4a87f24e347420efb3e46555ff",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.949711,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_sorrentino/rivals_sorrentino-lod3.glb",
    "bytes": 243520,
    "sha256": "ea906ca61fc12004951e618f659867c6a3af68929fdc25f92e340c0d106dba2f",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.945878,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 },
 {
  "id": "rivals_volkov",
  "name": "VOLKOV",
  "club": "rivals",
  "role": "player",
  "staffRole": null,
  "number": 8,
  "position": "CM",
  "starter": true,
  "foot": "R",
  "kit": "away",
  "declaredHeightM": 1.84,
  "lods": [
   {
    "lod": 0,
    "url": "/characters/cast-opt/rivals_volkov/rivals_volkov-lod0.glb",
    "bytes": 1795780,
    "sha256": "d7220e765e4eaf4dbeafd9c48b93c7e46ceb8f589c4af00f1e846e1abc2fd3e4",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 29262,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.88,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 1,
    "url": "/characters/cast-opt/rivals_volkov/rivals_volkov-lod1.glb",
    "bytes": 1654856,
    "sha256": "609f11e943a3d04978e1157f36e616aa456069fb1d0c9782201e5d0b8b1142d3",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 24999,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.880111,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 2,
    "url": "/characters/cast-opt/rivals_volkov/rivals_volkov-lod2.glb",
    "bytes": 1048392,
    "sha256": "082ee3fe00e60f88b3fc8c4d873b045e7d93451dade0b5fb1b7269f22e24123b",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 10000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.880416,
    "soleM": 0,
    "textureVramBytes": 22369621
   },
   {
    "lod": 3,
    "url": "/characters/cast-opt/rivals_volkov/rivals_volkov-lod3.glb",
    "bytes": 244472,
    "sha256": "60380b4f74f5b95660f0522dd886f40416705f4d99c428cf7bcfb2b766d42a7c",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "textures": 1,
    "triangles": 3000,
    "bones": 74,
    "rootBone": "root",
    "sockets": 12,
    "maxInfluences": 4,
    "animations": 0,
    "heightM": 1.886138,
    "soleM": 0,
    "textureVramBytes": 22369621
   }
  ]
 }
];

/** Declared in the roster but with no built model in the served tree. */
export const CAST_MISSING_IDS: readonly string[] = [];

export const CAST_TOTALS = {
 "charactersDeclared": 36,
 "charactersBuilt": 36,
 "charactersMissing": 0,
 "fileBytes": 169525988
};

const BY_ID = new Map(CAST_CHARACTERS.map((c) => [c.id, c]));

export function castCharacter(id: string): CastCharacter | undefined {
  return BY_ID.get(id);
}

export function castLodAsset(id: string, lod: CastLodLevel): CastLodAsset | undefined {
  return BY_ID.get(id)?.lods.find((l) => l.lod === lod);
}

/** Club squad in shirt-number order: the XI first, then the bench. */
export function castSquad(club: string): readonly CastCharacter[] {
  return CAST_CHARACTERS.filter((c) => c.role === 'player' && c.club === club)
    .slice()
    .sort((a, b) => Number(b.starter) - Number(a.starter) || a.number - b.number);
}

export const CAST_CLUBS: readonly string[] = [
  ...new Set(CAST_CHARACTERS.filter((c) => c.club).map((c) => c.club as string)),
];

export function castStaff(staffRole: string): CastCharacter | undefined {
  return CAST_CHARACTERS.find((c) => c.staffRole === staffRole);
}
